import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3.75 9.5a8.25 8.25 0 1 1 16.5 0c0 2.093-.713 4.1-1.675 5.86-1.145 2.094-2.673 3.898-3.902 5.171a30 30 0 0 1-1.559 1.501 22 22 0 0 1-.596.514l-.035.028-.01.008-.004.003L12 22l-.469.585-.004-.003-.01-.008-.035-.028-.129-.108a29.453 29.453 0 0 1-2.025-1.907c-1.23-1.273-2.758-3.077-3.903-5.171C4.463 13.6 3.75 11.593 3.75 9.5M12 22l-.469.585c.274.22.664.22.938 0zm0-.985.116-.102c.37-.331.89-.816 1.478-1.424 1.178-1.22 2.608-2.916 3.664-4.849.89-1.628 1.492-3.383 1.492-5.14a6.75 6.75 0 0 0-13.5 0c0 1.757.602 3.512 1.492 5.14 1.056 1.933 2.486 3.629 3.664 4.85A28 28 0 0 0 12 21.015",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8.25 9.5a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0M12 7.25a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }